import Swiper from 'swiper/bundle';

let swiper_banner = new Swiper('.swiper-banner', {
  loop: true,
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
  },
  speed: 1200,
  navigation: {
    nextEl: '.swiper-img-next',
    prevEl: '.swiper-img-prev',
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
});
